import request from '@/utils/request'

/**
 * 禁用教师
 */
export function reqDisableTeacher(userId) {
    return request({
        url: '/system/sysUsers/disableUser',
        method: 'get',
        params: { userId }
    })
}

/**
 * 启用教师
 */
export function reqEnableTeacher(userId) {
    return request({
        url: '/system/sysUsers/disableUser',
        method: 'get',
        params: { userId }
    })
}
